import { render, staticRenderFns } from "./KeyCardDecoration.vue?vue&type=template&id=c6e67d9e&scoped=true"
import script from "./KeyCardDecoration.vue?vue&type=script&lang=js"
export * from "./KeyCardDecoration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e67d9e",
  null
  
)

export default component.exports